module.exports = __webpack_public_path__ + "static/media/live-chat2.c2591f2a.png";